import { ProfilSubmary } from "./profile-submary";

export interface RechercheMultiCriteres {
    id?: string;
    titre: string;
    auteurCreation?: ProfilSubmary;
    auteurModification?: ProfilSubmary;
    dateCreation?: string;
    dateModification?: string;
    createur?: string;
    modificateur?: string;
    criteres?: CritereRechercheMultiCriteres[];
    enabled?: boolean;
}

export interface CritereRechercheMultiCriteres {
    id?: string;
    critereName: string;
    critereType: string;
    conditionName: string;
    conditionValue: string;
    value: string;
    subValue: string;
    valueLabel: string;
    operator: string;
}

export interface CritereRecherche {
    id?: string;
    critereName: string;
    critereType: string;
    conditionName: string;
    conditionValue: string
    value: string;
    subValue: string;
    valueLabel: string;
    operator: string;
}

export class LabelValue {
    label: string;
    value: string;
}

export class CritereNode {
    children?: CritereNode[];
    name: string;
    type?: string;
}

export class CritereFlatNode {
    name: string;
    type: string;
    level: number;
    expandable: boolean;
}